import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { LANGUAGE_CODES } from "models";
import { NewsQueryKeys } from "modules/NewsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import i18n from "utils/i18n";

type ClickArticleNotificationPayload = {
  article_id: number;
  article_opened: boolean;
};

export const useClickArticleNotificationMutation = () => {
  const { selectedLocation } = useSelectedLocation();
  const locale = localStorage.getItem("locale") || i18n.language || LANGUAGE_CODES.English;

  return useTypedMutation<ClickArticleNotificationPayload, void>({
    mutationFn: async ({ article_id, article_opened }) => {
      await ApiInstance.post(
        "/articles/stripe/clicked",
        { article_id, article_opened, dealer_location_id: selectedLocation?.id, language_code: locale },
        ENV.dealerBaseURL
      );
    },
    onSuccess: () => typedQueryClient.setQueryData(NewsQueryKeys.unreadArticles, [])
  });
};
